import * as _4 from 'lodash4';
import { PathTask } from '../../data/builders/path_task_builder';
import { CurrentTopicsQuery } from '../../data/queries/current_topics_query';

export class TodoDetailsController {
  private taskDetails: any;
  private specialPresenter: any;
  private resources: any;
  private topics: CurrentTopicsQuery;
  private topic: any;
  private task: PathTask;
  private hasResources: boolean = false;
  private hasChildren: boolean = false;

  constructor(private $state: ng.ui.IStateService) {}

  $onInit(): void {
    this.task = this.taskDetails.source.task;
    this.hasResources = !_4.isEmpty(this.resources);
    this.hasChildren = !_4.isEmpty(this.taskDetails.root.children);
  }

  goToMajorSurvey(): void {
    this.$state.go(this.specialPresenter.stateName, this.specialPresenter.stateParams);
  }
}
export class TodoDetailsComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/todo_details/todo_details.html';
  public controller: any = TodoDetailsController;
  public bindings: any = {
    taskDetails: '<',
    specialPresenter: '<',
    resources: '<',
    topics: '<',
    topic: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/todo_details/todo_details.ts